import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';
import { SnackBarErrorConfig } from 'src/app/_utils/_material-import/snackbar-config';
import { CuentaRemuneradaData } from 'src/app/funds/public/_models/cuenta-remunerada-data';
import { CuentaRemuneradaService } from 'src/app/funds/public/_services/cuenta-remunerada.service';

@Component({
  selector: 'app-banner-funds-cta-corriente',
  templateUrl: './banner-funds-cta-corriente.component.html',
  styleUrls: ['./banner-funds-cta-corriente.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    BtnLinkComponent
  ]
})


export class BannerFundsCtaCorrienteComponent implements OnInit {
  @Input() domainUrl: string;
  isLoading: boolean = false;
  cuentaRemuneradaData: CuentaRemuneradaData;
  currentImageIndex: number = 0;
  animatedBackground: string[] = [
    'assets/videos/funds/cuenta-remunerada-1.png',
    'assets/videos/funds/cuenta-remunerada-2.png',
    'assets/videos/funds/cuenta-remunerada-3.png',
    'assets/videos/funds/cuenta-remunerada-4.png'
  ];

  constructor(
    private _cuentaRemuneradaService: CuentaRemuneradaService,
    private _matSnackBar: MatSnackBar
  ) { }

  ngOnInit(): void
  {
    this.animateBackground();
    this.getDatosCuentaRemunerada();
  }

  private animateBackground(): void
  {
    setInterval(() =>
    {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.animatedBackground.length;
    }, 1000);
  }

  getDatosCuentaRemunerada(): void
  {
    this._cuentaRemuneradaService.getCuentaRemuneradaData().subscribe({
      next: r =>
      {
        this.isLoading = false;
        this.cuentaRemuneradaData = r;
      },
      error: e =>
      {
        this.isLoading = false;
        this._matSnackBar.open(this._cuentaRemuneradaService.getServerErrors(e), 'x', new SnackBarErrorConfig());
      }
    });
  }

}


